export const DEBOUNCE_MS = 300;
export const MIN_SEARCH_LENGTH = 3;
export const DRIVERS_PAGE_SIZE = 20;
